module.exports = __webpack_public_path__ + "a67f66402dee3c4626bb61e94fc062a4.svg";